
import React from "react";

import useHomeIntelligenceData
    from "../../hooks/useHomeIntelligenceData";

import HomeIntelligenceChart
    from "./HomeIntelligenceChart";


//========================================================
// OMNISCAN PRO
// HOME BOX DATA ENERGY
//
// Energy & Utilities Monthly Trend
//
// Includes a portfolio total header matching
// the existing Home Utilisation component.
//
// Uses the existing Home Intelligence data hook
// and reusable amCharts v4 chart renderer.
//
// HomeBox and title are managed by HomeDataScroller.
//========================================================

export default function HomeBoxDataEnergy({
    isMobile = false
})
{

    //========================================================
    // Chart Configuration
    //========================================================

    const SUBJECT_ID = "energy";

    const CHART_TYPE = "Trend";

    const CHART_COLOR = "#E49A35";


    //========================================================
    // Intelligence Data
    //========================================================

    const {
        data,
        loading,
        error
    } = useHomeIntelligenceData(
        SUBJECT_ID,
        CHART_TYPE
    );


    //========================================================
    // Format Total Energy
    //========================================================

    const totalEnergy =
        data && Number.isFinite(Number(data.total))
            ? Number(data.total).toLocaleString("en-GB", {
                maximumFractionDigits: 0
            })
            : "—";


    //========================================================
    // Main Container
    //========================================================

    const thisContainer =
    {
        display: "flex",

        width: "100%",

        flexDirection: "column",

        height: isMobile
            ? "360px"
            : "440px",

        minHeight: 0,

        boxSizing: "border-box",

        background: "transparent",

        padding: isMobile
            ? "8px 10px 12px 10px"
           : "0px 14px 0px 0px"
    };


    //========================================================
    // Chart Panel
    //
    // Matches the existing Home metric pills.
    //========================================================

    const chartPanel =
    {
        display: "flex",

        flexDirection: "column",

        width: "100%",

        flex: "1 1 auto",

        minHeight: 0,

        position: "relative",

        overflow: "hidden",

        boxSizing: "border-box",

        background: "rgba(248,250,252,0.82)",

        border: "1px solid rgba(12,53,88,0.10)",

        borderRadius: "0px",

        boxShadow: "none"
    };


    //========================================================
    // Total Header
    //
    // Same styling as Home Utilisation.
    //========================================================

    const rowHeader =
    {
        display: "flex",

        width: "100%",

        height: "42px",

        flexShrink: 0,

        alignItems: "center",

        padding: "6px",

        boxSizing: "border-box",

        background: "rgba(25,29,33,0.045)",

        borderBottom: "1px solid rgba(25,29,33,0.09)"
    };


    //========================================================
    // Header Title
    //========================================================

    const rowHeaderTitle =
    {
        display: "flex",

        alignItems: "center",

        flex: 1,

        minWidth: 0,

        height: "28px",

        paddingLeft: "12px",

        color: "#344454",

        fontSize: "13px",

        fontWeight: 600,

        letterSpacing: "0.15px",

        boxSizing: "border-box"
    };


    //========================================================
    // Header Metric Holder
    //========================================================

    const rowHeaderMetricHolder =
    {
        display: "flex",

        alignItems: "center",

        height: "28px",

        flexShrink: 0
    };


    //========================================================
    // Header Metric Label
    //========================================================

    const rowHeaderMetricLabel =
    {
        display: "flex",

        alignItems: "center",

        justifyContent: "center",

        height: "28px",

        padding: "0px 10px",

        color: "#62686d",

        fontSize: "11px",

        fontWeight: 500
    };


    //========================================================
    // Blue Information Pill
    //
    // Same gradient as Home Utilisation.
    //========================================================

    const rowHeaderMetric =
    {
        display: "flex",

        alignItems: "center",

        justifyContent: "center",

        minWidth: "82px",

        height: "28px",

        padding: "0px 8px",

        flexShrink: 0,

        boxSizing: "border-box",

        background:
            "linear-gradient(180deg, #45afe0 0%, #2695cc 100%)",

        color: "#ffffff",

        fontSize: "16px",

        fontWeight: 700,

        fontVariantNumeric: "tabular-nums",

        boxShadow: `
            inset 0 1px 0 rgba(255,255,255,0.24),
            0 2px 5px rgba(38,149,204,0.18)
        `
    };


    //========================================================
    // Chart Container
    //========================================================

    const chartContainer =
    {
        display: "flex",

        width: "100%",

        flex: "1 1 auto",

        minHeight: 0,

        position: "relative",

        overflow: "hidden",

        boxSizing: "border-box",

        padding: isMobile
            ? "12px 8px 10px 4px"
            : "14px 10px 12px 6px"
    };


    //========================================================
    // Status Message
    //========================================================

    const statusMessage =
    {
        display: "flex",

        flex: 1,

        alignItems: "center",

        justifyContent: "center",

        color: "#475569",

        fontSize: "13px",

        fontWeight: 600
    };


    //========================================================
    // Render
    //========================================================

    return (

        <div style={thisContainer}>

            {/*==========================================
                ENERGY INTELLIGENCE PANEL
            ==========================================*/}

            <div style={chartPanel}>

                {/*======================================
                    TOTAL ENERGY HEADER
                ======================================*/}

                <div style={rowHeader}>

                    <div style={rowHeaderTitle}>
                        Total Energy (kWh)
                    </div>

                    <div style={rowHeaderMetricHolder}>

                        <div style={rowHeaderMetricLabel}>
                            Total
                        </div>

                        <div style={rowHeaderMetric}>
                            {loading || error ? "—" : totalEnergy}
                        </div>

                    </div>

                </div>


                {/*======================================
                    ENERGY & UTILITIES MONTHLY TREND
                ======================================*/}

                <div style={chartContainer}>

                    {loading ? (

                        <div style={statusMessage}>
                            Preparing energy intelligence...
                        </div>

                    ) : error ? (

                        <div style={statusMessage}>
                            Energy intelligence unavailable
                        </div>

                    ) : data ? (

                        <HomeIntelligenceChart
                            data={data}
                            chartType={CHART_TYPE}
                            color={CHART_COLOR}
                        />

                    ) : (

                        <div style={statusMessage}>
                            No energy data available
                        </div>

                    )}

                </div>

            </div>

        </div>

    );

}
